import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, setBlockTracking as _setBlockTracking, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "super"
}
const _hoisted_2 = { class: "name" }

import { computed } from 'vue';

import * as utils from '@services/utils/common';

import type { IHeadRow } from '@typings';

import CheckCircle from 'vue-material-design-icons/CheckCircle.vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'RowHead',
},
  __name: 'RowHead',
  props: {
    item: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {



const props = __props;

const emit = __emit;

const name = computed(() => {
  return utils.getHeadRowName(props.item);
});

function click() {
  emit('click', props.item);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["head-row no-user-select", {
      selected: __props.item.selected,
      [`head-row--${__props.item.dayId}`]: true,
    }]),
    style: _normalizeStyle({ height: `${__props.item.size}px` })
  }, [
    (__props.item.super !== undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.item.super), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "main",
      onClick: click
    }, [
      _cache[0] || (
        _setBlockTracking(-1, true),
        (_cache[0] = _createVNode(CheckCircle, {
          size: 20,
          class: "select"
        })).cacheIndex = 0,
        _setBlockTracking(1),
        _cache[0]
      ),
      _createElementVNode("span", _hoisted_2, _toDisplayString(name.value), 1)
    ])
  ], 6))
}
}

})